export const SUPPORTED_LOCALES = ["en", "es", "zh", "fr-CA"] as const;

export const SUPPORTED_LOCALE_SET = new Set<string>(SUPPORTED_LOCALES);

export const DEFAULT_LOCALE: SupportedLocale = "en";

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export function normalizeLocale(
  locale: string | string[] | undefined | null,
): SupportedLocale {
  let localeValue: string | undefined;
  if (typeof locale === "string") {
    localeValue = locale;
  } else if (Array.isArray(locale)) {
    localeValue = locale[0];
  }

  if (!localeValue) return DEFAULT_LOCALE;

  if (SUPPORTED_LOCALES.includes(localeValue as SupportedLocale)) {
    return localeValue as SupportedLocale;
  }

  return DEFAULT_LOCALE;
}

export function getAcceptedLanguage(locale: SupportedLocale): string {
  const entry = acceptedLanguages.find(lang => lang.code === locale);
  return entry ? entry.acceptedLanguage : "en-US";
}

export const acceptedLanguages = [
  { code: "en", acceptedLanguage: "en-US" },
  { code: "es", acceptedLanguage: "es-ES" },
  { code: "zh", acceptedLanguage: "zh-CN" },
  { code: "fr-CA", acceptedLanguage: "fr-CA"},
];